import qs from "query-string";

export const getPath = (state) => state.getIn(["router", "location", "pathname"]);

export const getQuery = (state) => qs.parse(state.getIn(["router", "location", "search"]));
